export default "__VITE_ASSET__1ec70352__"